export default function FloatingButtons() {
  const phoneNumber = "+916304824076"; // Replace with your WhatsApp number
  const message = "Hi! I would like to know more about your services.";

  const instagramUrl =
    "https://www.instagram.com/sreesunrisemakeup?igsh=MTkxcXpoZml2bW80cw==";

  return (
    <>
      {/* Floating Button Group */}
      <div className="fixed bottom-20 right-5 flex flex-col items-center gap-3 z-50">
       

        {/* Instagram Button */}
        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-14 h-14 bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 text-white rounded-full shadow-lg shadow-pink-500/40 transition transform hover:scale-105"
          title="Follow us on Instagram"
          aria-label="Follow us on Instagram"
        >
          {/* Instagram Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="1.8"
            className="w-5 h-5"
          >
            <rect x="3" y="3" width="18" height="18" rx="5" />

            <circle cx="12" cy="12" r="4" />

            <circle
              cx="17.5"
              cy="6.5"
              r="1"
              fill="currentColor"
              stroke="none"
            />
          </svg>
        </a>

         {/* WhatsApp Button */}
        <a
          href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(
            message,
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg shadow-green-500/40 transition transform hover:scale-105 "
          title="Chat on WhatsApp"
          aria-label="Chat on WhatsApp"
        >
          {/* WhatsApp Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 32 32"
            className="w-5 h-5"
          >
            <path d="M16.002 3C9.373 3 4 8.373 4 15c0 2.648.783 5.097 2.14 7.143L4 29l7.137-2.128C13.051 28.214 14.494 28.5 16 28.5c6.627 0 12-5.373 12-12.002S22.629 3 16.002 3zm0 22.5c-1.356 0-2.666-.27-3.863-.803l-.278-.128-4.236 1.264 1.25-4.12-.144-.289A9.472 9.472 0 0 1 6.5 15c0-5.238 4.262-9.5 9.5-9.5 5.237 0 9.5 4.262 9.5 9.5s-4.263 9.5-9.498 9.5zm5.396-7.297c-.295-.148-1.743-.861-2.015-.959-.271-.1-.47-.147-.67.147-.198.295-.77.959-.945 1.157-.174.197-.348.222-.643.074-.295-.148-1.243-.459-2.367-1.462-.874-.777-1.462-1.732-1.636-2.027-.174-.295-.018-.455.13-.603.134-.133.295-.348.443-.521.148-.174.197-.295.295-.492.1-.197.049-.369-.025-.521-.074-.148-.67-1.611-.917-2.207-.24-.579-.484-.5-.67-.51l-.57-.01c-.197 0-.521.074-.792.369s-1.04 1.016-1.04 2.48c0 1.463 1.065 2.875 1.213 3.07.148.197 2.097 3.205 5.085 4.492.711.307 1.265.49 1.697.628.713.227 1.362.195 1.875.119.572-.086 1.743-.711 1.99-1.398.246-.688.246-1.277.172-1.398-.073-.12-.27-.197-.565-.345z" />
          </svg>
        </a>
      </div>
    </>
  );
}
